import { html, View } from 'rune-ts';
import klass from './TermsModal.module.scss';
import { typo } from '../../../../../shared/typography/typo';

export class TermsModalButton extends View {
  constructor() {
    super({});
  }

  texts = {
    submit: html.preventEscape(ET('mps2::ad_res::terms_modal::submit')),
  };

  override template() {
    return html`
      <div class="${klass.confirm_button_wrapper} ${typo('16_bold')}">
        <div class="${klass.confirm_button}">${this.texts.submit}</div>
      </div>
    `;
  }
}
